import { useQuery } from "@tanstack/react-query";
import { statusApi } from "@/lib/api";

export function useServerStatus() {
  return useQuery({
    queryKey: ["server-status"],
    queryFn: () => statusApi.get(),
    staleTime: 60_000,
    refetchInterval: 120_000,
  });
}